// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import CardCarouselController from "./card_carousel_controller"
application.register("card-carousel", CardCarouselController)

import CurrentPopperController from "./current_popper_controller"
application.register("current-popper", CurrentPopperController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatetimeFieldsController from "./datetime_fields_controller"
application.register("datetime-fields", DatetimeFieldsController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import OtherFieldController from "./other_field_controller"
application.register("other-field", OtherFieldController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import PopperController from "./popper_controller"
application.register("popper", PopperController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TrixEmbedController from "./trix_embed_controller"
application.register("trix-embed", TrixEmbedController)
